"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const t = require("babel-types");
// Consequents and alternatives in if statements must always be blocked,
// otherwise variable declaration get pulled outside the branch.
const ifStatement = function (path) {
    const { consequent, alternate } = path.node;
    if (t.isBlockStatement(consequent) === false) {
        path.node.consequent = t.blockStatement([consequent]);
    }
    if (alternate !== null && t.isBlockStatement(alternate) === false) {
        path.node.alternate = t.blockStatement([alternate]);
    }
};
const loop = function (path) {
    if (t.isBlockStatement(path.node.body)) {
        return;
    }
    path.node.body = t.blockStatement([path.node.body]);
};
const visitor = {
    IfStatement: ifStatement,
    "Loop": loop,
};
module.exports = function () {
    return { visitor: visitor };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFrZUJsb2NrU3RtdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3RzL21ha2VCbG9ja1N0bXQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFJQSxpQ0FBaUM7QUFFakMsd0VBQXdFO0FBQ3hFLGdFQUFnRTtBQUNoRSxNQUFNLFdBQVcsR0FBOEIsVUFBVSxJQUE2QjtJQUNwRixNQUFNLEVBQUUsVUFBVSxFQUFFLFNBQVMsRUFBRSxHQUFHLElBQUksQ0FBQyxJQUFJLENBQUM7SUFFNUMsSUFBSSxDQUFDLENBQUMsZ0JBQWdCLENBQUMsVUFBVSxDQUFDLEtBQUssS0FBSyxFQUFFO1FBQzVDLElBQUksQ0FBQyxJQUFJLENBQUMsVUFBVSxHQUFHLENBQUMsQ0FBQyxjQUFjLENBQUMsQ0FBQyxVQUFVLENBQUMsQ0FBQyxDQUFDO0tBQ3ZEO0lBRUQsSUFBSSxTQUFTLEtBQUssSUFBSSxJQUFJLENBQUMsQ0FBQyxnQkFBZ0IsQ0FBQyxTQUFTLENBQUMsS0FBSyxLQUFLLEVBQUU7UUFDakUsSUFBSSxDQUFDLElBQUksQ0FBQyxTQUFTLEdBQUcsQ0FBQyxDQUFDLGNBQWMsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUM7S0FDckQ7QUFDSCxDQUFDLENBQUM7QUFFRixNQUFNLElBQUksR0FBc0IsVUFBVSxJQUFzQjtJQUM5RCxJQUFHLENBQUMsQ0FBQyxnQkFBZ0IsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxFQUFFO1FBQUUsT0FBTztLQUFFO0lBQ2xELElBQUksQ0FBQyxJQUFJLENBQUMsSUFBSSxHQUFHLENBQUMsQ0FBQyxjQUFjLENBQUMsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUM7QUFDdEQsQ0FBQyxDQUFDO0FBRUYsTUFBTSxPQUFPLEdBQWE7SUFDeEIsV0FBVyxFQUFFLFdBQVc7SUFDeEIsTUFBTSxFQUFFLElBQUk7Q0FDYixDQUFDO0FBRUYsTUFBTSxDQUFDLE9BQU8sR0FBRztJQUNmLE9BQU8sRUFBRSxPQUFPLEVBQUUsT0FBTyxFQUFFLENBQUM7QUFDOUIsQ0FBQyxDQUFDIn0=


//////////////////
// WEBPACK FOOTER
// ../normalize-js/dist/ts/makeBlockStmt.js
// module id = 793
// module chunks = 0